import { render, staticRenderFns } from "./Map.vue?vue&type=template&id=1371710b&scoped=true"
import script from "./Map.vue?vue&type=script&lang=js"
export * from "./Map.vue?vue&type=script&lang=js"
import style0 from "./Map.vue?vue&type=style&index=0&id=1371710b&prod&scoped=true&lang=css"
import style1 from "./Map.vue?vue&type=style&index=1&id=1371710b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1371710b",
  null
  
)

export default component.exports
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QToggle,QBtn,QIcon});
